import * as React from "react";

import { IFormField } from ".";
import Input from "./Input";
import Select from "./Select";
import TextArea from "./TextArea";
import Checkbox from "./Checkbox";
import Radio from "./Radio";
import Range from "./Range";
// import Text from "@Components/Text";

const Field: React.ReactFCWithChildren<{
  value: string[] | string;
  field: IFormField;
  setFieldValue(field: string, value: any): void;
  handleBlur(e: React.FocusEvent<any>): void;
  handleChange(e: React.ChangeEvent<any>): void;
  autoHideLabels?: boolean;
  forceHideLabel?: boolean;
}> = ({
  field,
  handleChange,
  handleBlur,
  setFieldValue,
  value,
  autoHideLabels,
  forceHideLabel
}) => {
  switch (field.type) {
    case "input":
      return (
        <Input
          disabled={field.disabled}
          validation={field.validation}
          handleBlur={handleBlur}
          handleChange={handleChange}
          name={field.name}
          label={field.label}
          error={field.error}
          inputType={field.inputType}
          placeholder={field.placeholder}
          value={value}
          autoHideLabels={autoHideLabels}
          forceHideLabel={forceHideLabel}
          {...(field.inputOptions)}
        />
      );

    case "select":
      return (
        <Select
          validation={field.validation}
          handleBlur={handleBlur}
          disabled={field.disabled}
          handleChange={handleChange}
          name={field.name}
          label={field.label}
          error={field.error}
          options={field.options ? field.options.map(option => ({
            value: option.value,
            text: option.text,
            checked: option.value === field.value
          })) : []}
          value={value}
          fieldLogic={field.fieldLogic}
          unselectedOption={field.unselectedOption}
        />
      );

    case "textarea":
      return (
        <TextArea
          validation={field.validation}
          handleBlur={handleBlur}
          handleChange={handleChange}
          name={field.name}
          label={field.label}
          error={field.error}
          autoHideLabels={autoHideLabels}
          wysiwyg={field.wysiwyg}
          setFieldValue={setFieldValue}
        />
      );

    case "checkbox":
      return (
        <Checkbox
          validation={field.validation}
          handleBlur={handleBlur}
          handleChange={handleChange}
          value={value}
          setFieldValue={setFieldValue}
          name={field.name}
          label={field.label}
          error={field.error}
          options={field.options ? field.options : []}
        />
      );

    case "radio":
      return (
        <Radio
          validation={field.validation}
          handleBlur={handleBlur}
          handleChange={handleChange}
          name={field.name}
          label={field.label}
          error={field.error}
          options={field.options ? field.options : []}
        />
      );

    case "range":
      return (
        <Range
          validation={field.validation}
          range={field.range ? field.range : [ 0, 10 ]}
          handleBlur={handleBlur}
          handleChange={handleChange}
          name={field.name}
          label={field.label}
          error={field.error}
        />
      );

    default:
      return <></>;
  }
};

export default Field;
